import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {FullUser} from '../../model';
import {Observable} from 'rxjs';
import {AppState} from '../../../app.store';
import {Store} from '@ngrx/store';
import {LoadUser} from '../../state/user.actions';

@Component({
  selector: 'app-user-profile-container',
  templateUrl: './user-profile-container.component.html',
  styleUrls: ['./user-profile-container.component.css']
})
export class UserProfileContainerComponent implements OnInit, OnDestroy {
  user$: Observable<FullUser>;

  constructor(private route: ActivatedRoute,
              private store: Store<AppState>) { }

  ngOnInit() {
    const userId = this.route.snapshot.paramMap.get('userId');
    this.store.dispatch(new LoadUser(userId));
    this.user$ = this.store.select(state => state.user.users[userId]);
  }

  ngOnDestroy() {
  }

}
